<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body - EMPTY like original AngularJS -->
@if (modalTitle) {
<div class="modal-body" id="mainSection" [hidden]="minimise">

</div>
}

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  @if (isDelete) {
<button
          class="delete-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="deletePayment()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
}
  <button class="button-cancel"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
